export default __webpack_public_path__ + "static/media/astronaut.9f4c5e6d.png";